module.exports = __webpack_public_path__ + "static/img/img-vespa-sprint.1857f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-vespa-sprint.png
// module id = ueTB
// module chunks = 36